module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ClientDates"
  }, [(_vm.client || _vm.dates) ? _c('p', [(_vm.client) ? _c('span', [_vm._v(_vm._s(_vm.client))]) : _vm._e(), _vm._v(" "), (_vm.client && _vm.dates) ? _c('span') : _vm._e(), _vm._v(" "), (_vm.dates) ? _c('span', [_vm._v("(" + _vm._s(_vm.dates) + ")")]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19a188ea"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ClientDates.vue
// module id = 744
// module chunks = 1474